/**
 * Input validation handlers for quantity inputs
 */

import { showCustomPopup } from "../components/popup.js";
import { getWarehouseByCode } from "../utils/warehouseUtils.js";
import { updateTableRowSubtotals } from "../components/pricingGrid.js";
import { updateButtonStates } from "../components/dirtyTracking.js";

/**
 * Initialize input validation event handlers
 */
/** Apply or remove the green highlight based on the current input value. */
export function updateQtyHighlight($input: JQuery): void {
  const val = parseInt($input.val() as string) || 0;
  if (val > 0) {
    $input.addClass("has-qty");
  } else {
    $input.removeClass("has-qty");
  }
}

/**
 * Clamp to inventory, enforce warehouse case-pack multiples, normalize
 * empty/zero, and recompute the row subtotal + global dirty state for a
 * canonical pricing-grid input. Operates on the canonical
 * `.variant_qty_input_directship` element so existing row/cell lookup logic
 * continues to work.
 *
 * Shared between the canonical blur handler (below) and the mobile mirror
 * blur path so users who tap directly from a mobile mirror input to the
 * sticky Update Cart button can't submit an unrounded or over-inventory
 * value.
 */
export function normalizeAndValidateQuantityInput(input: HTMLInputElement): void {
  const $input = $(input);
  const $cell = $input.closest(".variant_cell");
  const userInput = parseInt($input.val() as string) || 0;
  const maxQty = parseInt($input.attr("max") ?? "0") || 0;
  const caseQty = parseInt($cell.attr("data-variant-case-qty") ?? "1") || 1;

  const $row = $cell.closest(".warehouse_row");
  const warehouseCode = $row.attr("data-warehouse-code") || "WPBR";
  const warehouse = getWarehouseByCode(warehouseCode);
  const requiresCaseQty = warehouse ? warehouse.RequiresCaseQuantity : false;

  $(".error_input_inventory").hide();
  $input.removeClass("error");

  if (userInput > maxQty) {
    showCustomPopup("Maximum quantity available is " + maxQty, 0);
    $input.val(maxQty);
  }

  if (requiresCaseQty && caseQty > 1 && userInput > 0) {
    if (userInput % caseQty !== 0) {
      const adjusted = Math.ceil(userInput / caseQty) * caseQty;
      const finalQty = Math.min(adjusted, maxQty);
      showCustomPopup(
        "This warehouse requires case quantities of " +
          caseQty +
          ". Adjusting to " +
          finalQty,
        0,
      );
      $input.val(finalQty);
    }
  }

  if (userInput <= 0) {
    $input.val("");
  }

  // Re-evaluate highlight after any value adjustments
  updateQtyHighlight($input);

  const productHandle = $row.attr("data-product-handle");
  if (productHandle) {
    const $allRows = $(
      `.warehouse_row[data-product-handle="${productHandle}"]`,
    );
    updateTableRowSubtotals($allRows);
  }

  // Value may have been clamped — re-evaluate global dirty state.
  updateButtonStates();
}

export function initInputValidation(): void {
  // Live highlight as the user types
  $(document).on(
    "input",
    ".variant_cell .variant_qty_input_directship",
    function () {
      updateQtyHighlight($(this));
      updateButtonStates();
    },
  );

  $(document).on(
    "blur",
    ".variant_cell .variant_qty_input_directship",
    function () {
      normalizeAndValidateQuantityInput(this as HTMLInputElement);
    },
  );

  $(document).on("click", ".variant_qty_input_directship", function () {
    $(".error_input_inventory").hide();
    $(this).removeClass("error");
  });
}
